// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { RouteRecordRaw } from 'vue-router';
import { RouteName } from './types';

const getPlayerRoutes = (tab: string) => [
  {
    path: `${tab}/${RouteName.Plan}/:id`,
    component: () => import('@/views/plan-details/plan-details-page.vue'),
  },
  {
    path: `${tab}/${RouteName.WorkoutPlayer}/:workoutEventId`,
    component: () => import('@/views/workout-player/workout-player-page.vue'),
  },
  {
    path: `${tab}/${RouteName.WorkoutPlayer}/:workoutEventId/finish`,
    component: () => import('@/views/workout-player/finish-workout-page.vue'),
  },
  {
    path: `${tab}/${RouteName.WorkoutPlayer}/:workoutEventId/feedback`,
    component: () => import('@/views/workout-player/workout-feedback-page.vue'),
  },
  {
    path: `${tab}/${RouteName.WorkoutPlayer}/:workoutEventId/share`,
    component: () => import('@/views/workout-player/workout-share-actions-page.vue'),
  },
  {
    path: `${tab}/${RouteName.Post}/:workoutEventId`,
    component: () => import('@/views/post/post-create-page.vue'),
  },
  {
    path: `${tab}/${RouteName.Story}/:workoutEventId`,
    component: () => import('@/views/story/story-create-page.vue'),
  },
];
const getChatRoutes = (tab: string) => [
  {
    path: `${tab}/${RouteName.Chat}/:id`,
    component: () => import('@/views/chat-details/chat-details-page.vue'),
  },
  {
    path: `${tab}/${RouteName.Chat}`,
    component: () => import('@/views/chat/chat-page.vue'),
  },
];
const getOtherUserRoutes = (tab: string) => [
  {
    path: `${tab}/${RouteName.UserProfile}/:userId`,
    component: () => import('@/views/user-profile/pages/other-profile-page.vue'),
  },
];

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: `/${RouteName.App}/${RouteName.Feed}`,
  },
  {
    path: `/${RouteName.Login}`,
    name: RouteName.Login,
    component: () => import('@/views/login/login-page.vue'),
    meta: {
      requireUnAuth: true,
    },
  },
  {
    path: `/${RouteName.Signup}`,
    name: RouteName.Signup,
    component: () => import('@/views/signup/signup-page.vue'),
    meta: {
      requireUnAuth: true,
    },
  },
  {
    path: `/${RouteName.ForgotPassword}`,
    name: RouteName.ForgotPassword,
    component: () => import('@/views/forgot-password/forgot-password-page.vue'),
    meta: {
      requireUnAuth: true,
    },
  },
  {
    path: `/${RouteName.Onboarding}`,
    name: RouteName.Onboarding,
    component: () => import('@/views/onboarding/onboarding-page.vue'),
  },
  {
    path: `/${RouteName.Questionnaire}`,
    name: RouteName.Questionnaire,
    component: () => import('@/views/questionnaire/user-profile-questionnaire-page.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: `/${RouteName.Questionnaire2}`,
    name: RouteName.Questionnaire2,
    component: () => import('@/views/questionnaire/user-profile-questionnaire-page-2.vue'),
  },
  {
    // Date of birth before the GYMing account exists (new Google / Apple identity), or once
    // for an existing account without one (?mode=profile).
    path: `/${RouteName.CompleteRegistration}`,
    name: RouteName.CompleteRegistration,
    component: () => import('@/views/complete-registration/complete-registration-page.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    // An account whose date of birth is under 13: no normal app access.
    path: `/${RouteName.AgeRestricted}`,
    name: RouteName.AgeRestricted,
    component: () => import('@/views/complete-registration/age-restricted-page.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: `/${RouteName.PrivacyPolicy}`,
    name: RouteName.PrivacyPolicy,
    component: () => import('@/views/user-profile/pages/privacy-policy-page.vue'),
  },
  {
    path: `/${RouteName.TermsOfUse}`,
    name: RouteName.TermsOfUse,
    component: () => import('@/views/user-profile/pages/terms-of-use-page.vue'),
  },
  {
    path: `/${RouteName.App}`,
    component: () => import('@/components/shared/app-navbar.vue'),
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: '',
        redirect: `/${RouteName.App}/${RouteName.Feed}`,
      },
      {
        path: RouteName.Feed,
        component: () => import('@/views/feed/feed-page.vue'),
      },
      {
        path: `${RouteName.Feed}/a/:attribute`,
        name: RouteName.Feed + 'ByAttribute',
        component: () => import('@/views/plan/plan-by-attributes.vue'),
      },
      ...getPlayerRoutes(RouteName.Feed),
      ...getOtherUserRoutes(RouteName.Feed),
      ...getChatRoutes(RouteName.Feed),
      {
        path: `${RouteName.Feed}/${RouteName.Notifications}`,
        component: () => import('@/views/alert/alert-page.vue'),
      },
      {
        path: `${RouteName.Feed}/${RouteName.Search}`,
        component: () => import('@/views/search/search-page.vue'),
      },
      {
        path: `${RouteName.Feed}/${RouteName.Recommendations}`,
        component: () => import('@/views/feed/pages/recommendations-page.vue'),
      },
      {
        path: `${RouteName.Feed}/${RouteName.Leaderboard}`,
        component: () => import('@/views/leaderboard/leaderboard-page.vue'),
      },
      {
        path: RouteName.Routine,
        component: () => import('@/views/routine/views/routine-page.vue'),
      },
      {
        path: `${RouteName.Routine}/${RouteName.CustomizePlan}`,
        component: () => import('@/views/routine/views/plan-customize-page.vue'),
      },
      {
        path: `${RouteName.Routine}/${RouteName.FilteredPlans}`,
        component: () => import('@/views/routine/views/filtered-plans-page.vue'),
      },
      {
        path: `${RouteName.Routine}/${RouteName.WorkoutHistory}`,
        component: () => import('@/views/user-profile/pages/workout-history-page.vue'),
      },
      ...getPlayerRoutes(RouteName.Routine),
      {
        path: RouteName.Group,
        component: () => import('@/views/group/group-page.vue'),
      },
      {
        path: `${RouteName.Group}/${RouteName.CreateGroup}/:groupId?`,
        component: () => import('@/views/group-create/create-group-page.vue'),
      },
      {
        path: `${RouteName.Group}/${RouteName.InviteToGroup}/:groupId`,
        component: () => import('@/views/group-create/invite-to-group-page.vue'),
      },
      {
        path: `${RouteName.Group}/${RouteName.InvitedToGroup}/:groupId`,
        component: () => import('@/views/group-create/invited-to-group-page.vue'),
      },
      {
        path: `${RouteName.Group}/:groupId/${RouteName.Leaderboard}`,
        component: () => import('@/views/leaderboard/leaderboard-page.vue'),
      },
      {
        path: `${RouteName.Group}/:groupId`,
        component: () => import('@/views/group-details/group-details-page.vue'),
      },
      {
        path: `${RouteName.Group}/${RouteName.GroupHistory}`,
        component: () => import('@/views/group/group-history-page.vue'),
      },
      ...getPlayerRoutes(RouteName.Group),
      ...getChatRoutes(RouteName.Group),
      ...getOtherUserRoutes(RouteName.Group),
      {
        path: RouteName.Explore,
        component: () => import('@/views/plan/plan-page.vue'),
      },
      ...getPlayerRoutes(RouteName.Explore),
      {
        path: RouteName.UserProfile,
        component: () => import('@/views/user-profile/pages/user-profile-page.vue'),
      },
      ...getOtherUserRoutes(RouteName.UserProfile),
      ...getChatRoutes(RouteName.UserProfile),
      {
        path: `${RouteName.UserProfile}/${RouteName.EditProfile}`,
        component: () => import('@/views/user-profile/pages/edit-profile-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.ChangePassword}`,
        component: () => import('@/views/user-profile/pages/change-password-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.ActivityLog}`,
        component: () => import('@/views/user-profile/pages/activity-log-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.LikeExercises}`,
        component: () => import('@/views/user-profile/pages/liked-ex-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.HiddenExercises}`,
        component: () => import('@/views/user-profile/pages/hidden-ex-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.PrivacyPolicy}`,
        component: () => import('@/views/user-profile/pages/privacy-policy-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.TermsOfUse}`,
        component: () => import('@/views/user-profile/pages/terms-of-use-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.Followers}`,
        component: () => import('@/views/user-profile/pages/user-followers-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.WorkoutHistory}`,
        component: () => import('@/views/user-profile/pages/workout-history-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.Settings}`,
        component: () => import('@/views/user-profile/pages/settings-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.MutedUsers}`,
        component: () => import('@/views/user-profile/pages/muted-users-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.SavedPosts}`,
        component: () => import('@/views/user-profile/pages/saved-posts-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.FitnessProfile}`,
        component: () => import('@/views/user-profile/pages/fitness-profile-page.vue'),
      },
      {
        path: `${RouteName.UserProfile}/${RouteName.PostView}/:postId`,
        component: () => import('@/views/user-profile/pages/post-view-page.vue'),
      },
      {
        // Legacy Post History → redirect to profile Posts section
        path: `${RouteName.UserProfile}/${RouteName.PostHistory}`,
        component: () => import('@/views/user-profile/pages/post-history-page.vue'),
      },
      ...getPlayerRoutes(RouteName.UserProfile),
    ],
  },
];
